import {Component, OnInit, ViewChild} from '@angular/core';
import {MultiCrudDataSource} from '../../../table-datasouces/multi-crud.datasource';
import {Order, OrderWithIdent} from '../../../dto/order';
import {toDateString} from '../../../providers/app-date-adapter';
import {byNumeric} from 'iso-country-codes';
import {OrdersService} from '../../services/orders.service';
import {OrderStatus} from '../../../dto/order-status';
import {MatTableGeneratorComponent} from '../../../shared/mat-table-generator/mat-table-generator.component';
import {FileHelper} from '../../../helpers/file-helper';
import {ActivatedRoute, Router} from '@angular/router';
import {PepStatus} from '../../../dto/pep-status';
import {IdentStatus} from '../../../dto/ident-status';
import {ToastService} from 'angular-toastify';
import {ContentRowField} from '../../../shared/content-row/content-row.component';

@Component({
  selector: 'app-order-export-all',
  templateUrl: './order-export-all.component.html',
  styleUrls: ['./order-export-all.component.css']
})
export class OrderExportAllComponent implements OnInit {
  public _isSendingOrdersToPortal: boolean;

  constructor(
    private ordersService: OrdersService,
    private router: Router,
    private route: ActivatedRoute,
    private _toastService: ToastService,
  ) { }

  @ViewChild(MatTableGeneratorComponent, { static: true }) table: MatTableGeneratorComponent;

  dataSource = new MultiCrudDataSource(this.ordersService, {
    getManyOverride: (
      pageIndex, pageSize, sortField, sortDirection, filterString, dateFilterCols, startFilterDate, endFilterDate, someAdditionalData, additionalFilterData, enumFilter, companiesFilter) => {
      const fs = this.ordersService.getExportable(
        pageIndex,
        pageSize,
        sortField,
        sortDirection,
        filterString,
        dateFilterCols,
        startFilterDate,
        endFilterDate,
        someAdditionalData,
        additionalFilterData,
        enumFilter,
        companiesFilter
      );
      return fs;
    }
  });

  columns = [
    { columnDef: 'creationDate', header: 'Creation date', cell: (row: OrderWithIdent) => `${toDateString(row.creationDate) || ''}`, sortable: false },
    { columnDef: 'ident', header: 'Ident', sortable: false,
      icon: (row: OrderWithIdent) => {

        if ( row.customerPepStatus == PepStatus.possibleMatch || row.customerPepStatus == PepStatus.confirmedMatch ) {
          return 'report_problem';
        }

        if (row.shippedDate) {
          return false;
        }
        if ( row.customerIdentStatus != IdentStatus.success && row.productIsNoIdentCreationActive ) {
          return false; // ready for export, but no-ident settings
        }
        if ( row.customerIdentStatus != IdentStatus.success && !row.productIsNoIdentCreationActive ) {
          return 'access_time'; // not ready for export
        }

        if ( row.customerIdentStatus == IdentStatus.success ) {
return 'beenhere';
}

        return false;
      },
      cellColor: (row: OrderWithIdent) => {
        if ( row.customerPepStatus == PepStatus.confirmedMatch ) {
          return 'red';
        }
        if ( row.customerPepStatus == PepStatus.possibleMatch ) {
          return 'orangered';
        }

        if ( row.shippedDate ) {
          return false;
        }
        if ( row.customerIdentStatus == IdentStatus.success ) {
          return '#8bc34a'; // ready for export
        }
        if ( row.productIsNoIdentCreationActive ) {
          return 'gray'; // ready for export, but no-ident settings
        }
        if ( !row.productIsNoIdentCreationActive ) {
          return 'orangered'; // not ready for export
        }
        return false;
      },

      cell: (row: OrderWithIdent) => {
        if ( row.customerPepStatus == PepStatus.possibleMatch || row.customerPepStatus == PepStatus.confirmedMatch ) {
          return 'PEP';
        }

        if ( row.shippedDate ) {
          return toDateString(row.shippedDate); // display shipping date if shipped
        }
        if ( row.customerIdentStatus != IdentStatus.success  && row.productIsNoIdentCreationActive ) {
          return 'SDD'; // ready for export, but no-ident settings
        }

        return '';
      }
    },
    { columnDef: 'countryName', sortable: false, header: 'Country', cellFlag: (row: OrderWithIdent) => byNumeric[row.countryIsoCode.toString().padStart(3, '0')].alpha2, cell: (row: OrderWithIdent) => byNumeric[row.countryIsoCode.toString().padStart(3, '0')].alpha2, },
    { columnDef: 'firstName', sortable: false, header: 'First Name', cell: (row: OrderWithIdent) => `${row.firstName}`, cellColor: (row: OrderWithIdent) => {
        if ( row.customerPepStatus == PepStatus.confirmedMatch ) {
          return 'red';
        }
        if ( row.customerPepStatus == PepStatus.possibleMatch ) {
          return 'orangered';
        }
        return false;
      }
    },
    { columnDef: 'lastName', sortable: false, header: 'Last Name', cell: (row: OrderWithIdent) => `${row.lastName}`, cellColor: (row: OrderWithIdent) => {
        if ( row.customerPepStatus == PepStatus.confirmedMatch ) {
          return 'red';
        }
        if ( row.customerPepStatus == PepStatus.possibleMatch ) {
          return 'orangered';
        }
        return false;
      } },
    { columnDef: 'dob', sortable: false, header: 'Date of birth', cell: (row: OrderWithIdent) => `${toDateString(row.dob) || ''}` },
    { columnDef: 'email', sortable: false, header: 'Email', cell: (row: OrderWithIdent) => `${row.email}` },
    { columnDef: 'productName', sortable: false, header: 'Product', cell: (row: OrderWithIdent) => row.productShortName || row.productName },
    { columnDef: 'status', sortable: false, header: 'Status', cell: (row: OrderWithIdent) => `${row.statusName}` },
    // { columnDef: "city", header: "City", cell: (row: Order) => `${row.city}` },
    // { columnDef: "externalRef", header: "ExternalRef", cell: (row: Order) => `${row.externalRef}` },
    { columnDef: 'cardName', sortable: false, header: 'Card name', cell: (row: OrderWithIdent) => `${row.cardName}` },
    { columnDef: 'invoiceNumber', sortable: false, header: 'Invoice', cell: (row: OrderWithIdent) => `${row.invoiceNumber || '(none)'}` },

    /*{ columnDef: "cancellationInvoiceNumber", header: "Cancellation Invoice", cell: (row: OrderWithIdent) => `${row.cancellationInvoiceNumber || "(none)"}` },*/


    { columnDef: 'orderDate', header: 'Order date', cellColor: (row: OrderWithIdent) => row.isReorderOrder ? 'lightskyblue':null, cell: (row: OrderWithIdent) => {
        let ret = toDateString(row.orderDate) || '';
        if ( row.isImported ) {
          ret += ' (i)';
        }
        if ( row.isReorderOrder ) {
          ret += ' R';
        }
        return ret;
      }
    } as ContentRowField<OrderWithIdent>,

    /*{ columnDef: "partnerCustomerId", header: "Partner #", cell: (row: OrderWithIdent) => `${row.partnerCustomerId || ""}` },*/
  ] as ContentRowField<OrderWithIdent>[];

  ngOnInit(): void {
  }


  getViewLink = (item: Order): string => '../' + item.id.toString();

  getEditLink = (item: Order): string => item.status >= OrderStatus.Shipped ? null : item.id.toString() + '/edit';

  showError(message) {
    this._toastService.error(message);
  }

  exportAllOrders() {

    alert('This method is deprecated, please use the send orders to portal button');
    return;


    this.ordersService.exportExportable(this.dataSource.filter)
      .subscribe(result => {
        FileHelper.saveFile(result);

        this.dataSource.loadData();

      });
  }

  sendAllOrdersToPortal() {
    this._isSendingOrdersToPortal = true;
    this.ordersService.sendExportableToPortal(this.dataSource.filter)
      .subscribe(batchId => {

        this._toastService.success('Card creation batch ' + batchId + ' was created');

        this.dataSource.loadData();
        this._isSendingOrdersToPortal = false;


        this.router.navigate(['../card-creations/' + batchId], {relativeTo: this.route}).then();



      }, err => {
        this._isSendingOrdersToPortal = false;

        this.showError(err.error.message || err.error || err.message || err);

      });
  }

  returnBack() {
    this.router.navigate(['..'], { relativeTo: this.route }).then();
  }

  goToCardCreations() {
    this.router.navigate(['../card-creations'], { relativeTo: this.route }).then();
  }
}
